interface SEOProps {
    title: string
    description?: string
    path?: string
    image?: string
    noIndex?: boolean
    type?: 'website' | 'article'
}

const SITE_URL = 'https://cspgindia.in'
const SITE_NAME = 'Indian Studies Review'
const DEFAULT_DESCRIPTION =
    'Peer-reviewed bi-annual journal of the Centre for Study of Politics and Governance. Rigorous, India-rooted scholarship.'

export default function SEO({
    title,
    description = DEFAULT_DESCRIPTION,
    path = '/',
    image = '/og-image.svg',
    noIndex = false,
    type = 'website'
}: SEOProps) {
    const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`
    const url = `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`
    const imageUrl = image.startsWith('http') ? image : `${SITE_URL}${image}`

    return (
        <>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            {noIndex && <meta name="robots" content="noindex, nofollow" />}

            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={imageUrl} />
            <meta property="og:locale" content="en_IN" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={imageUrl} />
        </>
    )
}
